module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA8CAYAAABxVAqfAAAABHNCSVQICAgIfAhkiAAAAQhJREFUWIXt1jFqQkEQxvH/e3gAm3QKdmmTOoUiuYA2VkFyA1sFQRCSY4ilTbzCs/AegqXNu8GkSCKSandnfA9lpt7hx8DuN5uJyBPQA5pUUyVQZCIyqRA943kNKEAzrwEFwGGHHXbYYYcdviN4uqI7XdENPd+wQIdLxscTnfYDB2AX0qOe+A8FeOuHoWr4Ep2NWA9eOFwd1qDJsBZNgi3QaNgKjYIt0WDYGg2GH1t6KAn+fGf3m0p8bBhv9z/TXx0G+JqztsSjbrUlHv2OrfCk5LLAk7Nai6u2kwZX7+P/eGXwJf76TBHak4nIwgKPrdv/ZTrssMMOO+ywwyq4rMEtc6CoGC+B4hsLaXyTiGvjigAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ds-img/向左.png
// module id = 8iOD
// module chunks = 2